import axios from "axios";
import { cleanObject } from "helper/cleanObject";

export const questService = {
  async list(filter = {}) {
    let searchParams = new URLSearchParams(cleanObject(filter));
    return await axios.get("/quests/?" + searchParams.toString());
  },
  async create(payload) {
    return await axios.post("/quests", payload);
  },
  async remove(id) {
    return await axios.delete("/quests/" + id);
  },
  async view(id) {
    return await axios.get("/quests/" + id);
  },
  async update(id, payload) {
    return await axios.put("/quests/" + id, payload);
  },
};
